import { IServiceProvider } from "angular";
import {
  vsServiceName,
  PartTransactionDetailComponentRegistration,
  PartTransactionDetailComponentService,
} from "./service";

export const vsProviderName = `${vsServiceName}Provider`;

export class PartTransactionDetailComponentServiceProvider
  implements IServiceProvider
{
  static $inject = [];
  constructor() {}

  private registrations: PartTransactionDetailComponentRegistration[] = [];

  add(registration: PartTransactionDetailComponentRegistration) {
    this.registrations.push(registration);
  }

  $get: any = [
    (): PartTransactionDetailComponentService =>
      new PartTransactionDetailComponentService(this.registrations),
  ];
}
